import { Params, Router, UrlTree } from '@angular/router'

export type UrlTreeCreator = {
  createUrlTree: typeof Router.prototype.createUrlTree
}

export type UrlNavigator = {
  navigateByUrl: typeof Router.prototype.navigateByUrl
}

export const createLiveSignupUrlTree =
  (router: UrlTreeCreator) =>
  (liveEventSlug: string, queryParams: Params): UrlTree => {
    return router.createUrlTree(['signup'], { queryParams: { ...queryParams, redirect: `/live/${liveEventSlug}` } })
  }

export const routeToSignupPage =
  (router: UrlTreeCreator & UrlNavigator) => (liveEventSlug: string, queryParams: Params) => {
    const route = createLiveSignupUrlTree(router)(liveEventSlug, queryParams)
    return router.navigateByUrl(route)
  }

/**
 * Route to upgrade path with redirect back to original content, if present
 */
export const routeToUpgradePage =
  (router: UrlTreeCreator & UrlNavigator) => (liveEventSlug: string, queryParams: Params, liveEventName?: string) => {
    const updatedQueryParams = liveEventName
      ? { ...queryParams, redirect: `/live/${liveEventSlug}`, liveEventName }
      : { ...queryParams, redirect: `/live/${liveEventSlug}` }

    const route = router.createUrlTree(['account', 'change-offer', 'plans'], {
      queryParams: updatedQueryParams
    })
    return router.navigateByUrl(route)
  }
